import React, { useEffect } from 'react'
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { Icon } from '@iconify/react';
import "./styles.css"
import { useTranslation } from 'react-i18next';
import { Block, Inline } from '@comp/crRender';

const getMinDate = (year) => {
  return new Date(year, 0, 1)
}
const getMaxDate = (year) => {
  return new Date(year, 11, 31)
}

const DatePickerC = ({ minDate = new Date().getFullYear(), maxDate = new Date().getFullYear(), disabled, isRequired = true, className, formHandler, name, isSingle, defaultValue, label = null }) => {
  const { t } = useTranslation()
  const { formValues, handleFormValues } = formHandler

  const Apply = (date) => {
    handleFormValues(name, { value: date, isRequired, isError: false })
  }

  useEffect(() => {

    Apply(isSingle ? null : { from: null, to: null })
  }, [])

  useEffect(() => {
    if (defaultValue) {
      Apply(defaultValue)
    }
  }, [defaultValue])

  return (
    < div className={`DatePickerContainer col-md-4 ${className}`}>
      <Block isRender={name && !label} className={"col-sm-12 default-label"} >
        <span className='date-picker-label'> {t(name)} </span>
        <Inline isRender={isRequired} className={"required"}>*</Inline>
      </Block>
      <Block isRender={label} className={"col-sm-12 default-label"} >
        <span className='date-picker-label'> {t(label)} </span>
        <Inline isRender={isRequired} className={"required"}>*</Inline>
      </Block>

      <div className={`DatePicker ${formValues[name]?.isError ? "field-required" : ""}`}>
        <DatePicker
          showIcon
          icon={<Icon icon="ci:calendar-days" className='DateIcon' />}
          className="dateInput"
          toggleCalendarOnIconClick
          selectsRange={!isSingle}
          placeholderText={`${t('please-enter')} ${t(`${label || name}`)}`}
          startDate={!isSingle && formValues?.[name]?.value?.from}
          endDate={!isSingle && formValues?.[name]?.value?.to}
          selected={isSingle && formValues?.[name]?.value}
          showYearDropdown
          minDate={getMinDate(minDate)}
          maxDate={getMaxDate(maxDate)}
          yearDropdownItemNumber={50}
          scrollableYearDropdown
          allowIconClick={false}
          disabled={disabled}
          onChange={(d) => {
            Apply((isSingle) ? d : { from: d[0], to: d[1] })
          }}
          dateFormat="dd/MM/yyyy"
        />
      </div>
    </div >
  )
}
export default DatePickerC